import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export async function exportElementsToPdf(elements, options = {}) {
	const { scale = 2, maxSideMm = 297 } = options

	let doc = null

	for (let i = 0; i < elements.length; i++) {
		const el = elements[i]
		const rect = el.getBoundingClientRect()
		const aspect = rect.width / rect.height
		const widthMm = aspect >= 1 ? maxSideMm : maxSideMm * aspect
		const heightMm = aspect >= 1 ? maxSideMm / aspect : maxSideMm
		const orientation = aspect >= 1 ? 'landscape' : 'portrait'

		const canvas = await html2canvas(el, {
			scale,
			useCORS: true,
			backgroundColor: null,
		})
		const imgData = canvas.toDataURL('image/jpeg', 0.95)

		if (i === 0) {
			doc = new jsPDF({ orientation, unit: 'mm', format: [widthMm, heightMm] })
		} else {
			doc.addPage([widthMm, heightMm], orientation)
		}

		doc.addImage(imgData, 'JPEG', 0, 0, widthMm, heightMm)
	}

	return doc.output('blob')
}
